export default {
  fa: {
    loginSuccess: 'ورود موفق!',
    loginError: 'خطای ورود',
    panelTitle: 'پنل مدیریت هاگوارتز',
    username: 'نام کاربری',
    usernameRequired: 'نام کاربری الزامی است',
    password: 'رمز عبور',
    passwordRequired: 'رمز عبور الزامی است',
    loginButton: 'ورود',
  },
  en: {
    loginSuccess: 'Login successful!',
    loginError: 'Login failed',
    panelTitle: 'Hogwarts Admin Panel',
    username: 'Username',
    usernameRequired: 'Username is required',
    password: 'Password',
    passwordRequired: 'Password is required',
    loginButton: 'Log In',
  },
  de: {
    loginSuccess: 'Anmeldung erfolgreich!',
    loginError: 'Anmeldung fehlgeschlagen',
    panelTitle: 'Hogwarts-Verwaltungspanel',
    username: 'Benutzername',
    usernameRequired: 'Benutzername ist erforderlich',
    password: 'Passwort',
    passwordRequired: 'Passwort ist erforderlich',
    loginButton: 'Anmelden',
  },
  es: {
    loginSuccess: '¡Inicio de sesión exitoso!',
    loginError: 'Error al iniciar sesión',
    panelTitle: 'Panel de administración de Hogwarts',
    username: 'Nombre de usuario',
    usernameRequired: 'El nombre de usuario es obligatorio',
    password: 'Contraseña',
    passwordRequired: 'La contraseña es obligatoria',
    loginButton: 'Iniciar sesión',
  },
  fr: {
    loginSuccess: 'Connexion réussie !',
    loginError: 'Échec de la connexion',
    panelTitle: "Panneau d'administration de Poudlard",
    username: "Nom d'utilisateur",
    usernameRequired: "Le nom d'utilisateur est requis",
    password: 'Mot de passe',
    passwordRequired: 'Le mot de passe est requis',
    loginButton: 'Se connecter',
  },
  it: {
    loginSuccess: 'Accesso riuscito!',
    loginError: 'Accesso non riuscito',
    panelTitle: 'Pannello di amministrazione di Hogwarts',
    username: 'Nome utente',
    usernameRequired: 'Il nome utente è obbligatorio',
    password: 'Password',
    passwordRequired: 'La password è obbligatoria',
    loginButton: 'Accedi',
  },
  ja: {
    loginSuccess: 'ログインに成功しました!',
    loginError: 'ログインに失敗しました',
    panelTitle: 'ホグワーツ管理パネル',
    username: 'ユーザー名',
    usernameRequired: 'ユーザー名は必須です',
    password: 'パスワード',
    passwordRequired: 'パスワードは必須です',
    loginButton: 'ログイン',
  },
  ko: {
    loginSuccess: '로그인 성공!',
    loginError: '로그인 실패',
    panelTitle: '호그와트 관리 패널',
    username: '사용자 이름',
    usernameRequired: '사용자 이름은 필수입니다',
    password: '비밀번호',
    passwordRequired: '비밀번호는 필수입니다',
    loginButton: '로그인',
  },
  pt: {
    loginSuccess: 'Login realizado com sucesso!',
    loginError: 'Falha no login',
    panelTitle: 'Painel de Administração de Hogwarts',
    username: 'Nome de usuário',
    usernameRequired: 'O nome de usuário é obrigatório',
    password: 'Senha',
    passwordRequired: 'A senha é obrigatória',
    loginButton: 'Entrar',
  },
};
